module.exports = __webpack_public_path__ + "static/img/process-2.33056fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/insurance-new/process-2.png
// module id = m2Kz
// module chunks = 4